import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Frente from "./frente";
import Espalda from "./espalda";
import anime from "animejs";
import sync from "../../../assets/svg/sync.svg";
import { connect } from "react-redux";
import * as exerciseService from "../../../services/exercise";
import * as axios from "axios";
import QueryString from "qs";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

/*import right from '../../../assets/svg/right-arrow.svg'; */
class Content extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 768,
			model: "frente",
			show: true,
			apparatus: this.props.apparatus || [],
			email: "",
			name: "",
			list: "GYSR9VSCwLBHNosrwVq8hQ",
			formValid: false,
			emailValid: false,
			gdpr: false,
			captchaVerified: false,
		};

		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.animateSync = this.animateSync.bind(this);

		this.SendToSendy = this.SendToSendy.bind(this);
		this.handleUserInput = this.handleUserInput.bind(this);
		this.validateField = this.validateField.bind(this);
		this.handleVerify = this.handleVerify.bind(this);
	}

	handleVerify = (token) => {
		if (token) {
			this.setState({ captchaVerified: true });
		}
	};

	componentDidMount() {
		window.addEventListener("resize", this.updateWindowDimensions());
		/* this.animation2.add({
			targets: '.model',
			rotateY: ['180deg', '360deg'],
			begin: () => {
				this.setState({
					model: this.state.model === 'frente' ? 'espalda' : 'frente',
				});
			}
		}) */
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({ width: window.innerWidth });
	}
	/* animation2 = anime.timeline({
		duration: 509,
		easing: 'linear',
		
	}); */
	animateSync() {
		anime({
			targets: ".flip_inner",
			rotateY: { value: "+=180" },
			easing: "easeInOutSine",
			duration: 400,
			begin: () => {
				this.setState({
					model: this.state.model === "frente" ? "espalda" : "frente",
				});
			},
		});
	}
	handleClose() {
		this.setState({ show: false });
	}
	/*Chest: "Pectoral",
  Forearms: "Antebrazos",
  Back: "Espalda",
  Quadriceps: "Cuadriceps",
  Hamstrings: "Isquiosurales",
  Calves: "Pantorrillas",
  "Triceps Brachii": "Triceps",
  "Trapezius": "Trapecios",
  Shoulders: "Hombros",
  "Waist": "Abdominales",
  "Hips": "Gluteos",
  "Biceps Brachii": "Biceps",
  Hip Adductor: "Aductores",
  Abductors: "Abductores",*/

	groupOrPart(musculo) {
		const bodyPart = [
			"Shoulders",
			"Forearms",
			"Back",
			"Trapezius",
			"Chest",
			"Waist",
			"Hips",
			"Calves",
		];
		const muscleGroup = [
			"Triceps Brachii",
			"Biceps Brachii",
			"Abductors",
			"Quadriceps",
			"Hamstrings",
			"Hip Adductors",
		];
		if (bodyPart.indexOf(musculo) >= 0)
			return `bodypart=${musculo}&musclegroup=null`;
		return `bodypart=null&musclegroup=${musculo}`;
	}
	getFilter(apparatus = null, movement = null, utility = null) {
		localStorage.setItem(
			"filter",
			JSON.stringify({
				apparatus: this.state.apparatus,
				movement,
				utility,
				musculo: this.props.musculo,
			}),
		);
		return `exercisename=${null}&${this.groupOrPart(
			this.props.musculo,
		)}&apparatus=${
			this.state.apparatus
		}&difficulty=null&utility_name=${utility}&movement_name=${movement}&apparatus_groups_name=null&mechanics=null&force=null&synergists=null&stabilizers=null&movement=null&subcategory=null&lang=es`;
	}
	changeApparatus(e) {
		const apparatus = this.state.apparatus;
		const index = apparatus.indexOf(e.target.value);
		if (index >= 0) apparatus.splice(index, 1);
		else apparatus.push(e.target.value);
		this.setState({
			apparatus: apparatus,
		});
	}

	search() {
		this.props.selectMusculo(
			this.props.musculo,
			this.state.apparatus,
			this.getFilter(this.state.apparatus, null, null),
		);
		this.handleClose();
	}
	isDisabled(equipament) {
		return (
			this.state.apparatus.indexOf(equipament) < 0 &&
			this.state.apparatus.length == 3
		);
	}
	handleUserInput(e) {
		const name = e.target.name;
		const value = e.target.value;
		this.setState({ [name]: value });
		this.validateField(name, value);
	}
	validateField(fieldName, value) {
		let emailValid = this.state.emailValid;

		switch (fieldName) {
			case "email":
				emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
				break;
			default:
				break;
		}
		this.setState({
			emailValid: emailValid,
			formValid: emailValid,
		});
	}
	async SendToSendy() {
		// this.search();
		document.getElementById("loading").style.display = "block";
		var instance = axios.create();
		try {
			const name = this.state.name;
			const parts = name.split(" ");
			const firstName = parts.shift(); // Paul
			const lastName = parts.join(" ");
			const url = "https://services.leadconnectorhq.com/contacts/";
			var body = JSON.stringify({
				firstName,
				lastName,
				email: this.state.email,
				name: name,
				source: "Ejercicios",
				locationId: "qh2gWMwWy08RaBPYmU7H",
				tags: ["Ejercicios"],
			});
			const response = await axios({
				url: url,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
					Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
					version: "2021-07-28",
				},
				data: body, // Información enviada desde el cliente React
			});
			if (response) this.search();
		} catch (error) {
			if (error.response) {
				if (error.response.data?.meta?.contactId) {
					await this.changeTag(error.response.data?.meta?.contactId);
					this.search();
				}
				// Respuesta del servidor con error (422 en este caso)
				console.error("Error del servidor:", error.response.data);
			}
			console.log(error);
		}
	}
	async changeTag(contactId) {
		if (this.props.contactId) {
			const url = `https://services.leadconnectorhq.com/contacts/${contactId}/tags`;
			var body = JSON.stringify({
				tags: ["Calculadora de Calorías"],
			});
			const response = await axios({
				url: url,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
					Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
					version: "2021-07-28",
				},
				data: body,
			});
		}
	}
	render() {
		return (
			<div>
				<div className={"step"}>
					<span className={"step_number"}>1</span>
					<h6>Selecciona un grupo muscular </h6>
				</div>
				{this.state.width < 767 ? (
					<>
						<div className='flip'>
							<div className='flip_inner'>
								<div className='front'>
									<Frente />
								</div>
								<div className='back'>
									<Espalda />
								</div>
							</div>
						</div>
						<div className='sync'>
							<div onClick={this.animateSync}>
								<img src={sync} alt='sync' style={{ margin: "0 5px" }}></img>
								<p>Ver más grupos musculares</p>
							</div>
						</div>
						{/* <div className="twoarrows">
						<div className="arrowbtn">
							{this.state.model === 'espalda' ? (
								<label
									style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
									onClick={this.animateSync}>
									<img src={right} alt="right"></img>Girar
								</label>
							) : null}
						</div>
						<div className="arrowbtn">
							{this.state.model === 'frente' ? (
								<label
									style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
									onClick={this.animateSync}>
									<img src={left} alt="left"></img>Girar
								</label>
							) : null}
						</div>
					</div> */}
					</>
				) : (
					<div className='svgs row model ' style={{ padding: "20px 0" }}>
						{this.state.model === "frente" || this.state.width > 767 ? (
							<Frente />
						) : null}
						{this.state.model === "espalda" || this.state.width > 767 ? (
							<Espalda />
						) : null}
					</div>
				)}
				<div>
					<div className={"step"}>
						<span className={"step_number"}>2</span>
						<h6>Selecciona al menos un tipo de implemento (máximo 3)</h6>
					</div>
					<Form className={"checks"}>
						<Form.Check
							inline
							disabled={this.isDisabled("Assisted")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Assisted")}
							label='Asistido'
							name='implements'
							value='Assisted'
							type='checkbox'
							id='1-implement-1'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Barbell")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Barbell")}
							label='Barra'
							name='implements'
							value='Barbell'
							type='checkbox'
							id='1-implement-2'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Cable")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Cable")}
							label='Polea'
							name='implements'
							value='Cable'
							type='checkbox'
							id='1-implement-3'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Dumbbell")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Plyometric")}
							label='Pliométrico'
							name='implements'
							value='Plyometric'
							type='checkbox'
							id='1-implement-13'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Lever")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Dumbbell")}
							label='Mancuerna'
							name='implements'
							value='Dumbbell'
							type='checkbox'
							id='1-implement-4'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Sled")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Lever")}
							label='Máquina con discos'
							name='implements'
							value='Lever'
							type='checkbox'
							id='1-implement-5'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Smith")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Sled")}
							label='Trineo'
							name='implements'
							value='Sled'
							type='checkbox'
							id='1-implement-6'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Weighted")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Strech")}
							label='Estiramiento'
							name='implements'
							value='Strech'
							type='checkbox'
							id='1-implement-14'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Band-assisted")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Smith")}
							label='Máquina Smith'
							name='implements'
							value='Smith'
							type='checkbox'
							id='1-implement-7'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("BodyWeight")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Weighted")}
							label='Lastre'
							name='implements'
							value='Weighted'
							type='checkbox'
							id='1-implement-8'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Self-assisted")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Band-assisted")}
							label='Asistido con bandas'
							name='implements'
							value='Band-assisted'
							type='checkbox'
							id='1-implement-9'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Suspended")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("BodyWeight")}
							label='Peso corporal'
							name='implements'
							value='BodyWeight'
							type='checkbox'
							id='1-implement-10'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Plyometric")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Self-assisted")}
							label='Auto-asistido'
							name='implements'
							value='Self-assisted'
							type='checkbox'
							id='1-implement-11'
						/>
						<Form.Check
							inline
							disabled={this.isDisabled("Strech")}
							onChange={this.changeApparatus.bind(this)}
							checked={0 <= this.state.apparatus.indexOf("Suspended")}
							label='Suspendido'
							name='implements'
							value='Suspended'
							type='checkbox'
							id='1-implement-12'
						/>
					</Form>
				</div>
				<div className={"step"}>
					<span className={"step_number"}>3</span>
					<h6>
						Completa el formulario dejando tu nombre y correo, y luego haz click
						en "buscar ejercicios" para ver las mejores opciones y diseñar tu
						rutina completamente gratis
					</h6>
				</div>
				<div className='formSendy'>
					<Form>
						<Form.Group style={{ display: "flex", gap: "1rem" }}>
							<Form.Control
								name='name'
								value={this.state.name}
								type='text'
								placeholder='Aquí tu primer nombre...'
								isValid={this.state.emailValid && this.state.name !== ""}
								onChange={(event) => this.handleUserInput(event)}
								style={{ height: "60px" }}
								required
							></Form.Control>
							<Form.Control
								name='email'
								value={this.state.email}
								type='email'
								placeholder='Y aquí tu email...'
								isValid={this.state.emailValid && this.state.email !== ""}
								onChange={(event) => this.handleUserInput(event)}
								style={{ height: "60px" }}
								required
							></Form.Control>
						</Form.Group>
						<p>
							Al hacer click en "Buscar ejercicios", estás de acuerdo en que tus
							datos sean almacenados y tratados por FullMusculo LLC
						</p>
						<GoogleReCaptcha onVerify={this.handleVerify} />
						<Button
							disabled={
								this.state.apparatus.length <= 0 ||
								this.state.apparatus.length > 3 ||
								!this.state.emailValid ||
								this.state.name === "" ||
								!this.state.captchaVerified
							}
							onClick={() => this.SendToSendy()}
						>
							Buscar ejercicios
						</Button>
					</Form>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	musculo: state.musculo,
	apparatus: state.apparatus,
});
const mapDispatchToProps = (dispatch) => ({
	selectMusculo(musculo, apparatus, filter) {
		exerciseService
			.getExercises(filter)
			.then((res) => {
				var exercise = [];
				document.getElementById("loading").style.display = "none";
				for (const key in res.data.exercises) {
					if (Object.hasOwnProperty.call(res.data.exercises, key)) {
						exercise.push(res.data.exercises[key]);
					}
				}
				dispatch({
					type: "SELECT_MUSCULO",
					musculo,
					apparatus,
					ejercicios: exercise,
				});
			})
			.catch((err) => {
				document.getElementById("loading").style.display = "none";
				console.log(err);
			});
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
